import {PageContent} from '@/i18n/model/zh/page-content/page-content'

export const zh = {
  pageContent: PageContent,
}
